__turbopack_context__.v({
  "checkboxWrapper": "i78qXG_checkboxWrapper",
  "consentExpanded": "i78qXG_consentExpanded",
  "expandedAgreements": "i78qXG_expandedAgreements",
});
